/**
 * @generated SignedSource<<0f7026db7accc0caa31b6a36add067aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkComment_charge$data = {
  readonly comment: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkComment_charge";
};
export type PaymentLinkComment_charge$key = {
  readonly " $data"?: PaymentLinkComment_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkComment_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkComment_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "c86b2c9a115d9b9145c4b5a7e6f0357a";

export default node;
